import {useEffect} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';

/**
 * 구 고객센터 URL을 신규 고객센터 URL로 리다이렉트하는 훅
 *
 * 기존 help.sooplive.co.kr/atv.php?type=xxx 형태의 URL이
 * www.sooplive.co.kr/help/atv.php?type=xxx 형태로 변경되어
 * 레거시 URL 호환성을 위해 적절한 신규 경로로 리다이렉트 처리
 *
 * 처리 경로:
 * - /help/atv.php?type=xxx
 * - /help/m.php?category=xxx
 *
 * @returns {Object} shouldRedirect - 리다이렉트가 필요한 경로인지 여부
 */
const useHelpRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getRedirectPath = (type, qnaId, category) => {
    if (location.pathname.startsWith('/help/m.php')) {
      switch (category) {
        case 'NODE0000000473': // 이의신청
          return '/help/objection';
        default: // 1:1 문의
          return '/help/inquiry';
      }
    }
    switch (type) {
      // FAQ
      case 'exSelfRAR':
      case 'exSelfRARMobile':
      case 'exSelfRARView':
        return '/help/faq';

      // 1:1문의하기
      case 'exMailQuestion':
        return '/help/inquiry';

      // 신고하기
      case 'exMailDeclare':
        return '/help/report/content';
      case 'exMailIllegal':
        return '/help/report/illegal';

      // My문의내역
      case 'exMailMyBoard':
      case 'myBoardMobile':
        return '/help/my-inquiry';

      // My문의내역 상세
      case 'exMailMyAnswer':
      case 'myAnswerMobile':
        return qnaId ? `/help/my-inquiry/${qnaId}` : '/help/my-inquiry';

      // QnA 만족도 설문
      case 'customerSurvey':
        return qnaId
          ? `/help/my-inquiry/survey?inquiryId=${qnaId}`
          : '/help/my-inquiry';

      // 정지이의제기
      case 'exMailObjection':
        return '/help/objection';

      // 기본값
      case 'faqKeywordInsert':
      case 'index':
      default:
        return '/help';
    }
  };

  useEffect(() => {
    const isLegacyPath =
      location.pathname.startsWith('/help/atv.php') ||
      location.pathname.startsWith('/help/m.php');

    if (isLegacyPath) {
      const urlParams = new URLSearchParams(location.search);
      const type = urlParams.get('type');
      const qnaId = urlParams.get('qnaId');
      const category = urlParams.get('category');

      const redirectPath = getRedirectPath(type, qnaId, category);
      navigate(redirectPath, {replace: true});
    }
  }, [location.pathname, location.search, navigate]);

  // 리다이렉트가 필요한 경로인지 반환
  const shouldRedirect =
    location.pathname.startsWith('/help/atv.php') ||
    location.pathname.startsWith('/help/m.php');

  return {shouldRedirect};
};

export default useHelpRedirect;
